import { Link, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";

import { useAuthUser } from "@/lib/use-auth-user";

export function DashboardTopbar() {
  const navigate = useNavigate();
  const { user } = useAuthUser();

  return (
    <div className="sticky top-0 z-50 flex h-16 items-center justify-between border-b border-[#e2e8f0] bg-white px-5 md:px-10">
      <Link
        to="/me/meetups"
        className="font-serif text-[28px] font-semibold italic tracking-tight text-[#1a1a1a]"
      >
        Finally
      </Link>
      <button
        type="button"
        onClick={() => navigate("/me/account")}
        className="flex items-center gap-2.5 rounded-full px-2 py-1.5 transition hover:bg-[#f8fafc]"
      >
        <div className="h-9 w-9 overflow-hidden rounded-full border-2 border-[#e2e8f0] bg-gradient-to-br from-[#dbeafe] to-[#bfdbfe]">
          {user?.avatarUrl ? (
            <img src={user.avatarUrl} alt="" className="h-full w-full object-cover" />
          ) : null}
        </div>
        <span className="hidden text-[14px] font-semibold text-[#1a1a1a] sm:inline">
          {user?.fullName || "Account"}
        </span>
        <ChevronDown className="h-3.5 w-3.5 text-[#94a3b8]" />
      </button>
    </div>
  );
}
